import { apiClient } from './apiClient';
import type {
  LoginRequest,
  AuthResponse,
  RefreshSessionRequest,
  CurrentSessionResponse,
  PasswordResetRequest,
  OperationAccepted,
} from '../../api/types';

export async function login(data: LoginRequest): Promise<AuthResponse> {
  const { data: response } = await apiClient.post<AuthResponse>('/auth/login', data);
  return response;
}

export async function refreshSession(data: RefreshSessionRequest): Promise<AuthResponse> {
  const { data: response } = await apiClient.post<AuthResponse>('/auth/refresh', data);
  return response;
}

export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function getCurrentUser(): Promise<CurrentSessionResponse> {
  const { data: response } = await apiClient.get<CurrentSessionResponse>('/auth/me');
  return response;
}

export async function requestPasswordReset(data: PasswordResetRequest): Promise<OperationAccepted> {
  const { data: response } = await apiClient.post<OperationAccepted>(
    '/auth/password-reset/request',
    data,
  );
  return response;
}
